const requestStatus = {
  initial: 'initial',
  fetching: 'fetching',
  success: 'success',
  failure: 'failure',
} as const;

export default requestStatus;
